<template>
    <div>
        <LoadingOverlay :loading="loading" />
        <div class="weeklyRankRewards-tableSec">
            <div class="weeklyRankRewards-HD">Weekly Ranking Rewards</div>
            <div class="weeklyRankRewards-tableWrap">
                <table>
                    <tbody>
                        <tr v-for="reward in WeeklyRankRewardsRoomData" :key="reward.id">
                            <td>Top {{ reward.rank }}</td>
                            <td><span><img :src='beansIcon' class="beansIcon" alt="" /></span> {{ reward.reward_coin }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="rankingRewards-ruleCont">
            <ul>
                <li>Room rank is based on the Diamonds of the user consumed in the party room.</li>
                <li>The ranking updating is subjected to 00:00 (GMT +5:30).</li>
                <li>The Diamonds of lucky gifts aren't calculated.(comment)</li>
            </ul>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import beansIcon from '../../assets/images/beansIcon.png'
import LoadingOverlay from '../LoadingOverlay.vue'
export default {
    name: 'weeklyRankRewardsRoom',
    components: {
        LoadingOverlay
    },
    data() {
        return {
            WeeklyRankRewardsRoomData: [],
            beansIcon: beansIcon,
            loading: false
        }
    },
    mounted() {
        this.fetchWeeklyRankRewardsRoomData();
    },
    methods: {
        fetchWeeklyRankRewardsRoomData() {
            this.loading= true;
            const tokenParam = this.$route.params.token;
            const token = tokenParam.split('=')[0];
            const apiUrl = `api/top-privateroom-weekly?type=this_week`;
            axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
                .then(response => {
                    this.WeeklyRankRewardsRoomData = response.data.result.weeklyrewards;
                })

                .catch(error => {
                    console.error("Error Featching Weekly Data", error)
                })
                .finally(() => {
                    this.loading = false;
                })
        },
    },
}
</script>